import { connect } from "react-redux";
import { ApplicationState } from '../../store';
import * as ConstantsStore from '@store/constants';
import * as RequirementsStore from '@store/requirements';
import * as App from '@store/app';

import { RejectRequirement } from '../../components/requirements/RejectRequirement';

export default connect(
    (state: ApplicationState) => ({
        ...RequirementsStore.plainActions,
        user: state.identity?.user,
    }),
    {},
)(RejectRequirement as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any